import React from 'react';
import { Box, Card, CardContent, Typography, Chip } from '@mui/material';

const InsufficientCreditsPaidCard = ({ meta, toolDisplayName }) => {
  const available = Number(meta?.available_credits || 0);
  const required = Number(meta?.required_credits || 0);
  const missing = Math.max(0, required - available);
  const tname = toolDisplayName(String(meta?.tool_name || '').trim() || 'Requested analysis');
  const plan = String(meta?.user_plan || '').trim();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, width: '100%' }}>
      <Card
        sx={{
          maxWidth: { xs: '100%', sm: 900 },
          width: '100%',
          background: (theme) => theme.palette.grey[100],
          color: (theme) => theme.palette.text.primary,
          borderRadius: '20px 20px 20px 4px',
          boxShadow: 'none',
          border: (theme) => `1px solid ${theme.palette.divider}`
        }}
      >
        <CardContent sx={{ px: 2, py: 2 }}>
          <Typography variant="h6" sx={{ mb: 0.5 }}>
            Credits limit reached for your plan
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
            {tname} requires {required} credits. You have {available}.{missing > 0 ? ` You are short by ${missing} credits.` : ''}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 2 }}>
            <Chip size="small" label={`Required: ${required}`} />
            <Chip size="small" label={`Available: ${available}`} />
            {plan && <Chip size="small" color="info" label={`Plan: ${plan}`} />}
          </Box>
          <Typography variant="body2" color="text.primary">
            It looks like you spent all your credits for this period. If you need more, please reach out to us at{' '}
            <Typography
              component="a"
              variant="body2"
              href="mailto:info@askpot.com"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: 'underline' }}
            >
              info@askpot.com
            </Typography>{' '}
            and we will figure out the best option for you.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default InsufficientCreditsPaidCard;
